import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=5c296768"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c296768')) {
      api.createRecord('5c296768', component.options)
    } else {
      api.reload('5c296768', component.options)
    }
    module.hot.accept("./messageList.vue?vue&type=template&id=5c296768", function () {
      api.rerender('5c296768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/systemManage/messageList.vue"
export default component.exports